import React, {useState, useEffect} from 'react'
import {Button, Dropdown, Icon} from 'semantic-ui-react'

export const Selector = (props) => {
    const [content, setContent] = useState('');
    const [isEditable, setIsEditable] = useState(true);

    /*
    <Dropdown.Item text='In-App Link' onClick={() => props.onSelect('internallink')} />
    <Dropdown.Item text='Externer Link' onClick={() => props.onSelect('externallink')} />
    */

    return (
        <div>
            <div style={{
                display: 'inline-block',
                marginTop: '2em'
            }}>
                <Dropdown fluid text={(<div style={{
                        /*border: '1px solid #DDDDDD',
                        display: 'inline-block',
                        width: '2em',
                        height: '2em',
                        borderRadius: '1em',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'*/
                    }}><Button basic bordered circular icon="plus" color='grey' /></div>)}>
                    <Dropdown.Menu>
                        <Dropdown.Item text='Text / Markdown' onClick={() => props.onSelect('markdown')} />
                        <Dropdown.Item text='Bild' onClick={() => props.onSelect('image')} />
                        <Dropdown.Item text='Event Card' onClick={() => props.onSelect('eventcard')} />
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    )
}